import React, { useState } from "react";
import { Box, Card, Grid, Stack, Typography, } from "@mui/material";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import TitleBar from "components/TitleBar";




const usedColors = new Set();

const colorPalette = ["#343561", "#7F86A3", "#a3b7ca"];


const MoniteringAndMeasurement = ({ data }) => {
    const [isView, setIsView] = useState(false);
    const [rowData, setRowData] = useState(null);


    const barData = [

        { name: "No.of Internal Audit", y: data?.monitoringAndMeasurement?.internalAuditsByThirdPartyOrExternalAgency || 0 },
        { name: "No.of Site HSE Inspection", y: data?.monitoringAndMeasurement?.siteHSEInspectionsBySiteAndHSEManager || 0 },
         { name: "Stop Worked Notice Issued", y: data?.monitoringAndMeasurement?.stopWorkNoticeIssued || 0 },

    ];

    const chartData = barData.map((item, index) => ({
        y: item.y,
        name: item.name,
        color: colorPalette[index],
    }));


    const total = barData.reduce((sum, item) => sum + item.y, 0);


    const handleGetRisk = (point) => {
        setIsView((prev) => {
            const newState = !prev;
            setRowData(newState ? { Ageing: point } : null);
            return newState;
        });
    };

    const handleClose = () => {
        setIsView(false);
        setRowData(null);
    };


    const options = {

        chart: {
            type: 'column'
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            type: 'category',
            labels: {
                style: {
                    color: "#6B7280",
                    textOutline: 'none',
                    fontSize: "12px",
                    fontWeight: 600,
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Total value of Monitoring & Mesurement',
                style: {
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#182A4E",
                    fontFamily: "Outfit, sans-serif",
                }
            }
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true, 
                    format: '{point.y}', 
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#000',
                        textOutline: 'none'
                    }
                }
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            pointFormat: '{point.name}: <b>{point.y:.1f}</b>'
        },
        series: [{
            name: 'Hse Traing',
            data: chartData


        }],
        credits: {
            enabled: false,
        },
    };

    return (
        <Card sx={{
            background: "#fff",
            borderRadius: 1,
            padding: 0,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
            border: "1px solid #E4E4E4",
            height: "100%"
        }}>
            <Grid size={12}>
                <TitleBar title={"Monitoring & Measurement"} description={""} />
            </Grid>


            {total === 0 ? (
                <Typography
                    sx={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#9CA3AF",
                        fontSize: "14px",
                        fontWeight: 500
                    }}
                >
                    No Data Available
                </Typography>
            ) : (
                <HighchartsReact highcharts={Highcharts} options={options} />
            )}
        </Card>

    );
};

export default MoniteringAndMeasurement;